export default "__VITE_ASSET__gol0vU7v__"